function resolveBackendUrl() {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL;

  if (configuredUrl) {
    return configuredUrl;
  }

  return 'https://api.spellinnovation.com.np';
}

export const BACKEND_URL = resolveBackendUrl();
